module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-17.8af106e5.jpg";